

import React from "react";

type CardProps = {
  children: React.ReactNode;
  rounded?: string;
  className?: string;
  outline?: string;
  shadow?: string;
  header?: string;
  customHeader?: React.ReactNode;
  padding?: string;
  height?: string;
  width?: string;
  ref?: React.RefObject<HTMLDivElement | null>;
  justify?: string;
  headerStyle?: string;
  marginOuter?: string;
  border?: string;
  borderColor?: string;
  backgroundColor?: string;
  surfaceColor?: string;
  flex?: string;
  icon?: React.ElementType;
  iconActionOnClick?: (e: React.MouseEvent) => void;
  /** Accessible name for the header close/action icon button. */
  iconAriaLabel?: string;
  /**
   * The header icon button is held (e.g. a write is on its way and closing
   * would hide its outcome): `aria-disabled`, greyed, no click. Absent = today.
   */
  iconDisabled?: boolean;
  /** `aria-busy` on the header icon button — work in flight behind it. */
  iconBusy?: boolean;
  /** `data-testid` of the header icon button. */
  iconTestId?: string;
  headerClassName?: string;
};

export const Card: React.FC<CardProps> = ({
  children,
  surfaceColor = "surface-primary",
  rounded = "rounded-3xl",
  outline = "outline-primary",
  shadow = "shadow-2xl",
  className,
  header,
  customHeader,
  padding = "p-6",
  height = "h-auto",
  width = "w-[95vw] sm:max-w-125",
  ref,
  justify = "justify-center items-center",
  headerStyle = "h2",
  marginOuter = "",
  border = "border",
  borderColor,
  backgroundColor,
  flex = "flex flex-col",
  icon: Icon,
  iconActionOnClick,
  iconAriaLabel,
  iconDisabled = false,
  iconBusy = false,
  iconTestId,
  headerClassName,
}) => {
  return (
    <div
      ref={ref}
      style={{
        borderColor: borderColor,
        backgroundColor: backgroundColor,
      }}
      className={`${height} ${width} ${padding} ${rounded} ${shadow} ${marginOuter} ${surfaceColor} ${flex} ${border} ${outline} ${justify} ${className} `}
    >
      {(header || customHeader) && (
        <div className={`flex flex-row w-full ${headerClassName}`}>
          {customHeader ? (
            customHeader
          ) : (
            <h2 className={headerStyle}>{header}</h2>
          )}
          {Icon && (
            <button
              type="button"
              className={`ml-auto ${iconDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
              onClick={iconDisabled ? undefined : iconActionOnClick}
              aria-label={iconAriaLabel}
              aria-disabled={iconDisabled || undefined}
              aria-busy={iconBusy || undefined}
              data-testid={iconTestId}
              title={iconAriaLabel}
            >
              <Icon size={18} className="font-secondary" />
            </button>
          )}
        </div>
      )}
      {children}
    </div>
  );
};
